export class AbstractExternalSyncStorage {
    constructor(initialSnapshot) {
        this._listeners = [];
        this.subscribe = (callback) => {
            const wasEmpty = this._listeners.length === 0;
            this._listeners.push(callback);
            if (wasEmpty) {
                this.onSubscribe();
            }
            return () => {
                this._listeners = this._listeners.filter((listener) => listener !== callback);
                if (this._listeners.length === 0) {
                    this.onUnsubscribe();
                }
            };
        };
        this.getSnapshot = () => {
            return this._snapshot;
        };
        this._snapshot = initialSnapshot;
    }
    setSnapshot(snapshot) {
        this._snapshot = snapshot;
        this._listeners.forEach((listener) => listener());
    }
}
